import React, { useState, useEffect } from 'react';
import {
    Box,
    TextField,
    InputAdornment,
    List,
    ListItem,
    ListItemText,
    // Checkbox,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import SearchIcon from '@mui/icons-material/Search';
import { createTheme } from '@mui/material/styles';
const theme = createTheme();

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        width: '100%',
        border: '1px solid #ccccce',
        borderRadius: '4px',
        boxShadow: '4px 5px 4px #cccccc',
        backgroundColor: '#f5f5f5',
    },
    select: {
        padding: theme.spacing(2),
        '& label': {
            margin: theme.spacing(2),
        },
    },
    listItem: {
        cursor: 'pointer',
    },
}));

export default function UserList(props) {
    const classes = useStyles();

    const [search, setSearch] = useState('');
    const [list, setList] = useState([]);
    const [selectedVal, setSelectedVal] = useState(0);
    // const [selectAll, setSelectAll] = useState(false);
    // const [selectAllFlag, setSelectAllFlag] = React.useState(false);

    useEffect(() => {
        if (props.selected > 0) {
            setSelectedVal(props.selected);
        } else {
            setSelectedVal(0);
        }
    }, [props.selected]);
    // useEffect(() => {
    //     if (props.allSelect) {
    //         setSelectAll(false);
    //     }
    // }, [props]);

    useEffect(() => {
        if (selectedVal === 0 && props.participants.length > 0) {
            setList([...props.participants]);

            //let index= props.participants.find(x=>x.userID===props.se)
            setSelectedVal(props.participants[0].userID);
        } else {
            setList([...props.participants]);
            //setSelectedVal(props.participants[0].userID)
        }
    }, [props.participants, selectedVal]);

    const handleSearchChange = (event) => {
        let str = event.target.value;
        let value = str.replace(/^\s+/g, '');
        let modifyList = [];
        if (value.length > 0) {
            props.participants.forEach((item) => {
                let data = item;
                let keys = Object.keys(data);
                keys.forEach((key) => {
                    if (
                        typeof data[key] === 'string' &&
                        data[key].toLowerCase().indexOf(value.toLowerCase()) >
                            -1
                    ) {
                        if (modifyList.indexOf(item) == -1)
                            modifyList.push(item);
                    }
                });
            });
        } else {
            modifyList = [...props.participants];
        }
        setSearch(value);
        setList(modifyList);
    };

    const handleButtonClick = (id, type) => {
        setSelectedVal(id);
        props.handleUserClick(id, type);
    };
    // const handleSelectAll = (event) => {
    //     setSelectAll(!selectAll);
    //     props.selectAll(event);
    // };

    return (
        <Box component="div" className={classes.container}>
            {/* <FormControl fullWidth size='small' className={classes.select}>
                <InputLabel id="demo-simple-select-label">Select Type</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={filterType}
                    label="Selct Type"
                    onChange={handleChange}
                >
                    <MenuItem value='1'>Individual</MenuItem>
                    <MenuItem value='2'>Role</MenuItem>
                    <MenuItem value='3'>Tag</MenuItem>
                </Select>
            </FormControl> */}
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                {/* {props.participants && props.participants.length > 0 && (
                    <Checkbox
                        inputProps={{
                            'aria-label': 'AllParticipant',
                        }}
                        checked={selectAll}
                        onChange={(event) => handleSelectAll(event)}
                        color="secondary"
                        disabled={false}
                    />
                )} */}

                <TextField
                    id="search"
                    size="small"
                    label="Search"
                    value={search}
                    onChange={handleSearchChange}
                    autoComplete="off"
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        m: 0.5,
                        maxWidth: { xs: '180px', md: '90%' },
                    }}
                />
            </Box>

            <Box component="div">
                <List dense>
                    {list.length > 0 &&
                        list.map((item, index) => {
                            return (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                    }}
                                    key={index}>
                                    {/* <Checkbox
                                        inputProps={{
                                            'aria-label': 'Participant',
                                        }}
                                        checked={
                                            item.selected
                                                ? item.selected
                                                : false
                                        }
                                        onChange={(event) =>
                                            props.listSelect(event, item)
                                        }
                                        color="secondary"
                                        //value={row[row.key]}
                                        disabled={false}
                                    /> */}
                                    <ListItem
                                        selected={item.userID === selectedVal}
                                        key={index}
                                        className={classes.listItem}
                                        onClick={() =>
                                            handleButtonClick(item.userID)
                                        }>
                                        <ListItemText primary={item.name} />
                                    </ListItem>
                                </Box>
                            );
                        })}
                    {list && list.length === 0 && (
                        <ListItem sx={{ justifyContent: 'center' }}>
                            <Box>No data found</Box>
                        </ListItem>
                    )}
                </List>
            </Box>
        </Box>
    );
}
